// src/components/Global/Footer/Footer.jsx
import React from "react";
import "./Footer.css";

const Footer = () => {
  return (
    <footer className="footer">
      <span>© 2025 QC Tools</span>
      <span className="footer-separator">|</span>
      <span>Groupe QC/DQ</span>
    </footer>
  );
};

export default Footer;
